<template>
    <div :class="(navbar?'nossos-servicos-vertical':'')">
        <div v-if="!navbar" id="textoServico"><h1 class="textoNossosServicos  ml-4">Nossos <strong>Serviços</strong></h1></div>
        <div class="nossos-servicos-resolve">
            <div class="card-banner-resolve">
                <img class="banner-resolve" src="@/assets/imgs/nossos_servicos/banner-resolve.png" />
                <img class="logo-resolve" src="@/assets/imgs/nossos_servicos/logo-resolve.png" />
            </div>
            <img class="logo-resolve-mobile" src="@/assets/imgs/nossos_servicos/logo-resolve.png" />
            <div class="resolve-servico">
                <h2>Resolve</h2>
                <span>Negocie dívidas em seu CPF sem intermediários, cancele protestos em poucos minutos e receba comunicação 100% digital sobre pendências e soluções.</span>
                <button class="btn-primary" @click="abreResolve">Negociar Agora</button>
            </div>
        </div>
        <div class="cards-servicos">
            <div class="cards-servico-segment">
                <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'envio-de-titulo'}})">
                    <div class="icone-container">
                        <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-protesto.png" />
                    </div>
                    <h3>Protesto</h3>
                    <span>Solucione dívidas e protestos em um só lugar.</span>
                </div>
                <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'pedido-anuencia'}})">
                    <div class="icone-container">
                        <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-cancelamento.png" />
                    </div>
                    <h3>Cancelamento</h3>
                    <span>Autorização de Cancelamento (Carta de anuência eletrônica)</span>
                </div>
            </div>
            <div class="cards-servico-segment">
                <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'consulta-edital'}})">
                    <div class="icone-container">
                        <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-edital.png" />
                    </div>
                    <h3>Edital Eletrônico</h3>
                    <span>Consulta e emissão de edital eletrônico atualizado</span>
                </div>
                <div class="card-servico" @click="$router.push({name:'servico',params:{servico:'pedido-certidao'}})">
                    <div class="icone-container">
                        <img class="icone-card-servico" src="@/assets/imgs/nossos_servicos/icone-servico-certidao.png" />
                    </div>
                    <h3>Certidão</h3>
                    <span>Pedido de certidão e verificação de autenticidade</span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        navbar: Boolean,
        logged: Boolean,
    },
    data(){
        return {
            titulosSubmenu: false,
            anuenciaSubmenu: false,
            certidaoSubmenu: false,
        }
    },
    methods: {
        abreResolve(){
            window.open("https://resolve.cenprot.org.br/", "_blank");
        },
        servico(tab){
            this.$root.$emit('servicoclicado',tab)
            this.$emit('servicoclicado',tab)
        },
        toggleSubMenu(menu){
            switch (menu) {
                case 'titulo':
                    this.titulosSubmenu = !this.titulosSubmenu;
                    this.anuenciaSubmenu = false;
                    this.certidaoSubmenu = false;
                    break;
                case 'anuencia':
                    this.anuenciaSubmenu = !this.anuenciaSubmenu;
                    this.titulosSubmenu = false;
                    this.certidaoSubmenu = false;
                    break;
                case 'certidao':
                    this.certidaoSubmenu = !this.certidaoSubmenu;
                    this.titulosSubmenu = false;
                    this.anuenciaSubmenu = false;
                    break;
            }
        }
    }
}
</script>
<style scoped>
#textoServico{margin-top: calc(8%);}
.imgNossoServicos{margin-top: calc(40%);}
.tituloCardServicos{color: #69A9Fc;font-weight: bold;font-size: 16;}
.textoCardServicos{color: #084F84;font-size: 14px;}
.textoNossosServicos{color: #084f84;font-size: 29px;line-height: 25px;text-align: left;font-weight: bold;}
.nossos-servicos-home-card-header.bg-FFFFFF{border:3px solid; color: #1ACEB5; background-color: #1ACEB5;}
.card-header-logo-resolve{height:28px;width:auto;}
.card-resolve .nossos-servicos-home-card-bod-row a{height: fit-content !important;padding: 5px 24px;}
@media (min-width: 900px) {
  .textoNossosServicos{color: #084f84;font-size: 35px;padding:2px;text-align: left;}
}
.nossos-servicos-vertical{margin: 0 !important;box-shadow: 0px 0px 9px 0px #00000040;}
    .nossos-servicos-vertical .nossos-servicos-home-row {flex-flow: column;width: 100%;}
        .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card{width: 100%;margin: 0 !important;}
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-header{border-radius:0;}
               
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body{background-color:white;height: fit-content;padding: 0;}

            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile{cursor: pointer;}


            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(1) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(1) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(1) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#4BA56D;color:white;}
           
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#4780F1;color:white;}


            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#3791E7;color:white;}

            
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(4) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(4) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(4) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#16B0D2;color:white;}


            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(5) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(5) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem a,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(5) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:hover a{background-color:#1ACEB5;color:white;}
            
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:after{margin: 0;width: 100%;}
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row .nossos-servicos-item,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(3) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row a{height: 60px;}

            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem a{
                color:#ffffff;
                display: flex;
                flex-flow: column;
                height: 41px;
                line-height: 40px;
                padding: 0;
            }
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem a:not(:last-child):after{
                content:'';
                width: 201px;
                height: 1px;
                background-color: #ffffff;
                
            }
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{
                /* display: none; */
                height:0px;
                overflow:hidden;
                opacity: 0;
                /* position: absolute; */
                flex-flow: column;
                width: 300px;
                /* margin-top: 41px; */
                box-shadow: 0px 3px 6px #00000029;
            }
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card:nth-child(2) .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{
                /* margin-top: 60px; */
            }
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile.active .nossos-servicos-subitem,
            .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile:hover .nossos-servicos-subitem{display:flex;opacity: 1;height:fit-content;transition: height 1.3s ease-in;}

.nossos-servicos-resolve{
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    margin-bottom: 144px;
}
.nossos-servicos-resolve .card-banner-resolve{
    display: flex;
    width: 712px;
    height: 351px;
	border-radius: 50px;
	box-shadow: 4px 4px 50px 0 #D1DBE2;
    justify-content: space-between;
    align-items: center;
    padding: 0 0px 16px 22px;
}
.nossos-servicos-resolve .card-banner-resolve img.banner-resolve{
    align-self: end;
}
.nossos-servicos-resolve .card-banner-resolve img.logo-resolve{
    width: 173px;
    height: 43px;
    margin:0 auto;
}
.nossos-servicos-resolve img.logo-resolve-mobile{
    display: none;
}

.nossos-servicos-resolve .resolve-servico{
    display: flex;
    flex-flow: column;
    height: 351px;
    width: 447px;
    justify-content: center;
    margin-right: 108px;
    margin-left: auto;
}
.nossos-servicos-resolve .resolve-servico h2{
    font-family: 'Kanit', sans-serif;
    font-size: 42px;
    line-height: 77px;
    font-weight: 200;
    letter-spacing: -1%;
    color: var(--secondary-color);
    text-transform: none;
}
.nossos-servicos-resolve .resolve-servico span{
    font-family: 'Kanit', sans-serif;
    font-size: 16px;
    line-height: 27px;
    font-weight: 300;
    letter-spacing: -1%;
    color: var(--secondary-color);
    text-transform: none;
    margin-bottom: 63px;
}
.nossos-servicos-resolve .resolve-servico .btn-primary{
    width:272px;
    height: 49px;
}
.cards-servicos {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    max-width: 1387px;
    gap: 36px;
}
.cards-servicos .cards-servico-segment {
    display: flex;
    flex-wrap: wrap;
    gap: 36px;
}
.cards-servicos .cards-servico-segment .card-servico {
    display: flex;
    cursor: pointer;
    flex-flow: column;
	box-shadow: 4px 4px 50px 0 #D1DBE2;
	background: #FFFFFF;
    border-radius: 20px;
    padding: 10px 52px 40px 52px;
    width: 319px;
    height: 279px;
    justify-content: end;
    width: fit-content;
}
.cards-servicos .cards-servico-segment .card-servico .icone-container {display: flex;width: 100%;height:156px;align-items: center;justify-content: center;}
.cards-servicos .cards-servico-segment .card-servico .icone-container img.icone-card-servico {}
.cards-servicos .cards-servico-segment:nth-child(1) .card-servico:nth-child(1) .icone-container img.icone-card-servico {
    width: 81px;
    height: 81px;
}
.cards-servicos .cards-servico-segment:nth-child(1) .card-servico:nth-child(2) .icone-container img.icone-card-servico {
    width: 92px;
    height: 73px;
}
.cards-servicos .cards-servico-segment:nth-child(2) .card-servico:nth-child(1) .icone-container img.icone-card-servico {
    width: 126px;
    height: 67px;
}
.cards-servicos .cards-servico-segment:nth-child(2) .card-servico:nth-child(2) .icone-container img.icone-card-servico {
    width: 94px;
    height: 92px;
}

.cards-servicos .cards-servico-segment .card-servico h3 {
    font-family: 'Kanit', sans-serif;
    font-size: 24px;
    line-height: 37px;
    font-weight: 500;
    letter-spacing: -1%;
    color: var(--primary-color);
    text-transform: none;

}
.cards-servicos .cards-servico-segment .card-servico span {
    font-family: 'Kanit', sans-serif;
    font-size: 16px;
    line-height: 23px;
    font-weight: 300;
    letter-spacing: -1%;
    color: var(--secondary-color);
    text-transform: none;
    width: 214px;
}
@media (max-width:1300px){
    /* #nossos-servicos{margin: 0;margin-bottom: 74.5px;} */
        /* #nossos-servicos #textoServico{margin-bottom: 20px;} */
            /* #nossos-servicos #textoServico h1{font-family: 'Kanit', sans-serif;font-size: 20px;line-height: 32px;} */
        .nossos-servicos-home-row{flex-flow: column;max-width:calc(335px + 34px);margin:0 auto;}
        /* .nossos-servicos-vertical .nossos-servicos-home-row{max-width:300px;} */
        .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card{min-width: 300px;}
            .nossos-servicos-home-row .nossos-servicos-home-card{margin: 0;width: 100%;/*max-width: 335px;*/min-width: 335px;box-shadow:0px 3px 6px #00000029;}
                .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-header{border-radius: 0;}
                .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body{padding: 0;background-color: white;height: fit-content;}
                    .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row:after{margin: 0;width: 100%;}
    .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row .nossos-servicos-item:after {content: '';border-bottom: 3px solid #597EB5;border-right: 3px solid #597EB5;transform: rotate(45deg);width: 8px;height: 8px;position: absolute;right:46px;}
    .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{width:100%;}
    .nossos-servicos-vertical{width:100%;}
}
@media (max-width:420px) {
    /* #nossos-servicos{width:100%;} */
    .nossos-servicos-home-row{padding:0 17px}
    .nossos-servicos-home-row .nossos-servicos-home-card{min-width: unset;}
    /* .nossos-servicos-vertical .nossos-servicos-home-row .nossos-servicos-home-card .nossos-servicos-home-card-body .nossos-servicos-home-card-bod-row.mobile .nossos-servicos-subitem{width: 300px;} */
    .nossos-servicos-vertical .nossos-servicos-home-row{padding:0}
    
}

@media (max-width:1300px) {
    .exibe-gif-resolve {
        display: none;
    }
    .exibe-card-resolve{
        display: block;

    }
}

/* Para telas grandes */
@media (min-width: 1301px) {
    .exibe-gif-resolve {
        display: block;
        
    }
    .exibe-card-resolve{
        display: none;

    }
}

@media (max-width:1440px) {
    .nossos-servicos-resolve{justify-content: space-between;gap:50px;}
    .nossos-servicos-resolve .card-banner-resolve{
        width: 622px;
    }
    .nossos-servicos-resolve .resolve-servico{margin:unset;}
    .cards-servicos{justify-content: center;gap: 50px;}
    .cards-servicos .cards-servico-segment{gap: 50px;}

}
@media (max-width: 1200px){
    .nossos-servicos-resolve{justify-content: center;gap:30px;flex-flow: column;margin-bottom: 56px;}
    .nossos-servicos-resolve .card-banner-resolve{width: 100%;}
    .nossos-servicos-resolve .resolve-servico {margin: 0 auto;}
}
@media (max-width: 992px){
}
@media (max-width: 768px){
    .nossos-servicos-resolve .card-banner-resolve{
        box-shadow: none;
        padding: 0;
        height: fit-content;
    }
    .nossos-servicos-resolve .card-banner-resolve img.banner-resolve{
        width: 100%;
        height: auto;
    }
    .nossos-servicos-resolve .card-banner-resolve img.logo-resolve{
        display: none;
    }
    .nossos-servicos-resolve img.logo-resolve-mobile{
        display: flex;
        width: 173px;
        height: 43px;
        margin: 30px auto 0px auto;
    }
    
    .cards-servicos .cards-servico-segment{justify-content: center;}
}
@media (max-width: 600px){

    .nossos-servicos-resolve .resolve-servico {width: 100%;}
}
</style>